import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './FloatingActions.css';
import ContactModal from './ContactModal';

const FloatingActions = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [showContact, setShowContact] = useState(false);
  const { user, isShopper, isAdmin } = useAuth();
  const accountPath = user ? (isAdmin() ? '/admin/dashboard' : '/shopper/account') : '/login';

  return (
    <>
      <button
        className="fab fab-top fab-top-left"
        onClick={scrollToTop}
        aria-label="Back to top"
        title="Back to top"
      >
        ↑
      </button>
      <div className="floating-actions" aria-hidden={false}>
        <Link to={accountPath} className="fab fab-account" aria-label="Account" title="Account">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="22" height="22">
            <path fill="currentColor" d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5z" />
          </svg>
        </Link>
        <button
          className="fab fab-chat"
          onClick={() => setShowContact(true)}
          aria-label="Chat to us"
          title="Chat to us"
        >
          💬
        </button>
      </div>

      <ContactModal open={showContact} onClose={() => setShowContact(false)} />
    </>
  );
};

export default FloatingActions;
